import { useContext } from 'react';
import { StrategySchemaV2Context } from '../context/StrategySchemaV2ContextBase';

export const useStrategySchemaV2 = () => useContext(StrategySchemaV2Context);
